<template>
    <Base
        :inputs="getInputs()"
        @submitted="onSubmitted"
    >
        <template #header>
            <h1>Ansök och jämför flera kreditkort på 1 UC</h1>
            <p>Färdigställ din ansökan och få svar direkt.</p>

            <div v-if="showAuctionCards" class="form-container-cards">
                <prismic-image :src="cardsImageUrl" w="100" />
                <div class="form-container-cards__content">
                    <span class="header">{{ cardsHeader }}</span>
                    <span class="description">{{ cardsDescription }}</span>
                </div>
            </div>
            <expand 
                class="form-container-expander"    
                :button="$translate('card_application_info', 'Fördelar och information')"
            >
                <AuctionInformation />
            </expand>
        </template>
        <template #sidebar>
            <div 
                v-if="$store.state.settings.auction_image && $store.state.settings.auction_image.url" 
                class="sidebar-image"
            >
                <prismic-image
                    :img="$store.state.settings.auction_image"
                    :lazy="false"
                    w="200"
                />
            </div>
            <AuctionInformation />
        </template>

        <template #terms>
            <p class="terms">
                Genom att genomföra ansökan genom Kortio.se accepterar 
                du våra <nuxt-link to="/anvandarvillkor/">villkor</nuxt-link>.
            </p>
        </template>
    </Base>
</template>

<script>
import Base from '@/components/application/Base.vue';
import Expand from '@/components/slices/list/list-item/list-item-components/Expand.vue';
import Inputs from '@/mixins/inputs.js';
import AuctionInformation from '@/components/application/sidebar/AuctionInformation.vue';

import { initBucky, conversion as buckyConversion } from '@/plugins/bucky';

export default {
    mixins: [
        Inputs
    ],
    components: {
        Base, 
        Expand,
        AuctionInformation
    },
    data() {
        return {
            buckySessionId: null,

            showAuctionCards: false,
            cardsImageUrl: 'https://images.prismic.io/kortio/aDcAcCdWJ-7kSoFu_kort.png?auto=format,compress&w=100',
            cardsHeader: 'Ansök om flera kort på 1 UC',
            cardsDescription: 'Ansök om Bank Norwegian, Collector Easyliving och Resurs korten på 1 UC. Spara tid och få en bättre översikt över dina alternativ.',
        }
    },
    methods: {

        getInputs() {
            const inputs = {};

            inputs.credit = this.getCreditAmountInput(
                10000,
                200000
            );

            inputs.personalNumber = this.getPersonalNumberInput();
            inputs.phoneNumber = this.getPhoneNumberInput();
            inputs.email = this.getEmailInput();

            inputs.youQuestions = this.getSubHeader('Frågor om dig');
            inputs.employmentStatus = this.getEmploymentStatusInput();
            inputs.employmentTo = this.getEmploymentToInput();
            inputs.civilStatus = this.getCivilStatus();
            inputs.householdNumberChildren = this.getHouseholdNumberChildren();
            inputs.householdNumberAdults = this.getHouseholdNumberAdults();
            inputs.vehicleOwnershipCount = this.getVehicleOwnershipCountInput();
            
            inputs.economyQuestions = this.getSubHeader('Frågor om din ekonomi');
            inputs.monthlyIncome = this.getMonthlyIncomeInput();
            inputs.incomeSource = this.getIncomeSource();
            inputs.monthlyCreditCost = this.getMonthlyCreditCost();
            inputs.monthlyLivingCost = this.getMonthlyLivingCost();
            inputs.monthlyMortgageCost = this.getMonthlyMortgageCost();
            inputs.housing = this.getHousingInput();
            inputs.housingCost = this.getHousingCost();
            inputs.totalCreditAmount = this.getTotalCreditAmount();

            inputs.lawQuestions = this.getSubHeader('Frågor enligt penningstvättslagen');
            inputs.isPep = this.getPepInput();
            inputs.pepTitle = this.getPepTitleInput();
            inputs.pepConnectionRelation = this.getPepConnectionRelationInput();
            inputs.pepConnectionPersonalNumber = this.getPepConnectionPersonalNumberInput();
            inputs.pepConnectionName = this.getPepConnectionNameInput();
            inputs.pepConnectionCountry = this.getPepConnectionCountryInput();

            return inputs;
        },
        onSubmitted() {
            if (this.buckySessionId) {
                buckyConversion(this.buckySessionId);
            }
        }
    },
    async mounted() {
        const {
            variant, 
            session
        } = await initBucky('kortio_show_cards_in_auction');
        
        this.buckySessionId = session;
        
        if (variant === 'show_cards') {
            this.showAuctionCards = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.form-container-cards {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    width: 100%;

    @include spacing(padding,3);
    @include border-radius(10px);
    @include border(all,1px,$green);
    background: $graybg;
    @include spacing(margin,4,bottom);

    @media (max-width: 768px) {
        img {
            width: 70px;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        @include font-size(12px,8px);
        gap: 5px;
        color: $font;

        .header {
            font-weight: bold;
            color: $green;
        }
    }
}
</style>